import { gql, useQuery } from "@apollo/client";
import {
  FindPartnerExchangeRateByIdQueryQuery,
  FindPartnerExchangeRateByIdQueryQueryVariables,
} from "../../../../../schemaTypes";

export const findPartnerExchangeRateByIdQuery = gql`
  query FindPartnerExchangeRateByIdQuery($id: String!) {
    findPartnerExchangeRateById(id: $id) {
      id
      communityId
      communityName
      communityAlias
      rate
      createdAt
      updatedAt
      adminName
      adminLevel
    }
  }
`;

export interface WithFindPartnerExchangeRateById {
  id: string;
  communityId: string;
  communityName: string;
  communityAlias: string;
  rate: number;
  createdAt: string;
  updatedAt: string;
  adminName: string;
  adminLevel: string;
  loading: boolean;
}

interface Props {
  id: string;
  children: (data: WithFindPartnerExchangeRateById) => React.ReactElement | null;
}

export const FindPartnerExchangeRateByIdController: React.FC<Props> = ({
  id,
  children,
}) => {
  const { data, loading } = useQuery<
    FindPartnerExchangeRateByIdQueryQuery,
    FindPartnerExchangeRateByIdQueryQueryVariables
  >(findPartnerExchangeRateByIdQuery, {
    variables: { id },
  });

  const partnerExchangeRate = data?.findPartnerExchangeRateById;

  return children({
    id: partnerExchangeRate?.id || "",
    communityId: partnerExchangeRate?.communityId || "",
    communityName: partnerExchangeRate?.communityName || "",
    communityAlias: partnerExchangeRate?.communityAlias || "",
    rate: partnerExchangeRate?.rate || 0,
    createdAt: partnerExchangeRate?.createdAt || "",
    updatedAt: partnerExchangeRate?.updatedAt || "",
    adminName: partnerExchangeRate?.adminName || "",
    adminLevel: partnerExchangeRate?.adminLevel || "",
    loading,
  });
};
